const Flickity = require('flickity-bg-lazyload')
require('flickity-as-nav-for')
//require('flickity-imagesloaded')
require('flickity-fade')


const USE_FADE_FOR_HERO = true


document.addEventListener('DOMContentLoaded', () => {

  /**
   * Initialize gallery
   */
  const galleries = document.querySelectorAll('.gallery:not(.flickity-enabled)')
  for (var i = galleries.length - 1; i >= 0; i--) {
    let element = galleries[i]

    const buttonPrevious = element.parentElement.querySelector('.gallery-button-prev')
    const buttonNext     = element.parentElement.querySelector('.gallery-button-next')

    let options = {
      adaptiveHeight:  false,
      prevNextButtons: false,
      // imagesLoaded:    true,
      lazyLoad:        true,
      pageDots:        false
    }

    if (element.classList.contains('testimonials')) {
      Object.assign(options, {
        lazyLoad:   2,
        wrapAround: true,
        autoPlay:   2500
      })

    } else {

      Object.assign(options, {
        pageDots:     element.hasAttribute('data-use-dots'),
        draggable:    element.hasAttribute('data-use-drag')
      })
    }

    if (element.parentNode.parentNode.classList.contains('hero-gallery') && USE_FADE_FOR_HERO) {
      Object.assign(options, {
        fade: true,
        selectedAttraction: 0.4,
        friction: 0.9
      })
    }

    const flkty = new Flickity(element, options)

    if (buttonPrevious !== null) {
      if (!options.wrapAround) {
        buttonPrevious.setAttribute('disabled', true)
      }
      buttonPrevious.addEventListener('click', () => {
        flkty.previous()
      })

      buttonPrevious.addEventListener('mouseenter', () => {
        flkty.pausePlayer()

        buttonPrevious.addEventListener('mouseleave', () => {
          flkty.unpausePlayer()
        })
      })
    }

    if (buttonNext !== null) {
      buttonNext.addEventListener('click', () => {
        flkty.next()
      })

      buttonNext.addEventListener('mouseenter', () => {
        flkty.pausePlayer()

        buttonNext.addEventListener('mouseleave', () => {
          flkty.unpausePlayer()
        })
      })
    }

    if (buttonPrevious !== null && buttonNext !== null && !options.wrapAround) {
      flkty.on('cellSelect', () => {
        if (!flkty.cells[flkty.selectedIndex - 1]) {
          buttonPrevious.setAttribute('disabled', true)

        } else if(!flkty.cells[flkty.selectedIndex + 1]) {
          buttonNext.setAttribute('disabled', true)

        } else {
          buttonPrevious.removeAttribute('disabled')
          buttonNext.removeAttribute('disabled')
        }
      })
    }

  }



  /**
   * Initialize gallery navigation
   */
  const galleryNavs = document.querySelectorAll('.gallery-as-nav-for:not(.flickity-enabled)')

  for (var i = galleryNavs.length - 1; i >= 0; i--) {
    let element = galleryNavs[i]

    const mainGallerySelector = document.querySelector(element.getAttribute('data-as-nav-for'))
    const mainGallery = Flickity.data(mainGallerySelector)

    element.addEventListener( 'mouseenter', function() {
      mainGallery.pausePlayer()
      element.addEventListener( 'mouseleave', onNavMouseleave )
    })

    function onNavMouseleave() {
      mainGallery.unpausePlayer()
      element.removeEventListener( 'mouseleave', onNavMouseleave )
    }

    new Flickity(element, {
      lazyLoad: 3,
      bgLazyLoad: true,
      adaptiveHeight: true,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'center',

      asNavFor: mainGallerySelector,
    })

  }



  /**
   * Initialize hero gallery
   */
  const heroNav = document.getElementById('hero-nav')

  if (heroNav) {

    let buttons = heroNav.querySelectorAll('.hero-nav-list-item')
    let buttonsAsArray = Array.prototype.slice.call(buttons)

    let gallery = document.getElementById( heroNav.getAttribute('data-as-nav-for') )
    let flkty   = Flickity.data(gallery)

    const heroElement = heroNav.parentNode
    const heroLeft    = 2.5

    let heroHeight = null
    let totalHeight, currentHeight

    let originalIndex = 0, index
    let dropdownHeight

    let ratioDelta, newHeroLeft

    for (var i = buttons.length - 1; i >= 0; i--) {
      let button = buttons[i]

      button.addEventListener('mouseenter', () => {
        index = buttonsAsArray.indexOf(button)
        flkty.select(index + 1, false, !USE_FADE_FOR_HERO)
      })

      button.addEventListener('mouseleave', () => {
        flkty.select(originalIndex, false, !USE_FADE_FOR_HERO)
      })

      button.addEventListener('click', () => {

        // reset others
        for (var i = buttons.length - 1; i >= 0; i--) {
          buttons[i].classList.remove('-is-open')
        }
        heroElement.removeAttribute('style')

        button.classList.add('-is-open')

        if (heroHeight === null) {
          heroHeight = heroElement.clientHeight
        }

        scrollTop = window.pageYOffset

        dropdownHeight = button.querySelector('.hero-nav-list-dropdown').offsetHeight
        totalHeight = heroHeight + dropdownHeight

        ratioDelta = (totalHeight / heroElement.clientWidth) - (heroHeight / heroElement.clientWidth)
        newHeroLeft = heroLeft - ratioDelta - .065
        newHeroLeft = (Math.round(newHeroLeft * 100) / 100)

        heroElement.style.height = totalHeight + 'px'
        heroElement.style.left   = newHeroLeft * -1 + '%'
      })

    }

  }

})



// Load Resize Hack
window.addEventListener('load', () => {
  const flickityElements = document.querySelectorAll('.flickity-enabled')
  for (let i = 0; i < flickityElements.length; i++) {
    let flkty = Flickity.data(flickityElements[i])
    flkty.resize()
  }
})



// /**
//  * Fix some flickity resizing problems
//  */
// Flickity.prototype._createResizeClass = function() {
//   this.element.classList.add('flickity-resize')
// }

// Flickity.createMethods.push('_createResizeClass')

// const resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   this.element.classList.remove('flickity-resize')
//   resize.call(this)
//   this.element.classList.add('flickity-resize')
// };


// WEBPACK FOOTER //
// ./source/js/components/gallery.js